export default __webpack_public_path__ + "static/media/gallery_b-min.63dddb5b.jpg";